<template>
    <div class="number-has mt-4" data-element="porting-numbers-notice">
        <h4 class="mt-0">У вас есть номер, с которым вы не хотите расставаться?</h4>
        <p>
            Нет проблем,
            <a data-type="link" data-toggle="modal" data-target=".js-port-numbers-modal" class="dashed">подключите</a>
            его к Виртуальной АТС MANGO OFFICE
        </p>
    </div>
</template>

<script>
export default {
    name: "PortingForm"
}
</script>

<style scoped>

</style>